export const POPUP_CALL_TO_ACTION_BUTTON_CLICKED = 'POPUP_CALL_TO_ACTION_BUTTON_CLICKED';
export const SHOW_POPUP = 'SHOW_POPUP';
export const RESET_POPUP_INFO = 'RESET_POPUP_INFO';